import 'css-chunksrc/client/scenes/projectCreationForm/tagList/buttonTagForm/styles.scss';export default {
  "iconBox": "_iconBox_17r6a_1",
  "icon": "_icon_17r6a_1",
  "form": "_form_17r6a_14"
};